module.exports = __webpack_public_path__ + "media/images/vp/samples/06-c19413643674e243294b6c375e484690.jpg";